import styles from './FJProductToVideoStart.module.less';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import FJLocalStore from '../../../store/FJLocalStore.js';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import FJCloseIcon from '../../../assets/svg/textToVideo/close.svg?react';
import FJConfig from '../../../config/FJConfig.js';
import { PRODUCT_SUPPORT_LIST, PRODUCT_URL_EXAMPLE_LIST } from '../../../config/dataConfig/FJTextToVideoDataConfig';
import FJUtil from '../../../util/FJUtil.js';
import classNames from 'classnames';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller.jsx';
const FJProductToVideoStart = props => {
    const { productUrlToVideoInput, onChangeProductUrlToVideoInput, onAnalyzeProductUrl, uploadManually } = props;
    const _onChange = useCallback(
        e => {
            onChangeProductUrlToVideoInput(e.target.value);
        },
        [onChangeProductUrlToVideoInput],
    );
    const _onClose = useCallback(() => {
        onChangeProductUrlToVideoInput('');
    }, [onChangeProductUrlToVideoInput]);
    const _onSample = useCallback(() => {
        onChangeProductUrlToVideoInput(
            FJUtil.getRandomElementFromArray(PRODUCT_URL_EXAMPLE_LIST, productUrlToVideoInput),
        );
    }, [onChangeProductUrlToVideoInput, productUrlToVideoInput]);
    return (
        <FJVerticalScroller
            className={styles.container}
            style={{ backgroundImage: `url(${FJConfig.resourceImagePath}product-to-video-bg.png)` }}
        >
            <div className={styles.title}>{FJLocalStore._('ai-product-url-to-video')}</div>
            <div className={styles.support_text}>
                {FJLocalStore._('paste-your-product-url-here-or-upload-product-information-manually')}
            </div>
            <div className={styles.support_icon_box}>
                {PRODUCT_SUPPORT_LIST.map(item => (
                    <item.icon key={item.name} className={styles.support_icon} />
                ))}
            </div>
            <div className={styles.input_box}>
                <input
                    value={productUrlToVideoInput}
                    onChange={_onChange}
                    className={styles.input}
                    type='text'
                    placeholder={FJLocalStore._('paste-your-product-url-here')}
                />
                {productUrlToVideoInput && (
                    <div className={styles.close_icon_box} onClick={_onClose}>
                        <FJCloseIcon className={styles.close_icon} />
                    </div>
                )}
                <div className={styles.sample} onClick={_onSample}>
                    {FJLocalStore._('try-sample-links')}
                </div>
            </div>
            <div className={styles.btn_box}>
                <FJButton
                    text={FJLocalStore._('upload-manually')}
                    className={classNames(styles.btn, styles.upload_manually_btn)}
                    onClick={uploadManually}
                />
                <FJButton
                    text={FJLocalStore._('analyze-url')}
                    className={styles.btn}
                    type={'gradient'}
                    onClick={onAnalyzeProductUrl}
                />
            </div>
        </FJVerticalScroller>
    );
};

FJProductToVideoStart.propTypes = {
    productUrlToVideoInput: PropTypes.string.isRequired,
    onChangeProductUrlToVideoInput: PropTypes.func.isRequired,
    onAnalyzeProductUrl: PropTypes.func.isRequired,
    uploadManually: PropTypes.func.isRequired,
};

export default FJProductToVideoStart;
